import React, { useEffect, useState } from 'react';

import { translate } from '@portal/services/i18n';
import { maskMoney } from '@portal/services/masks';

import AdvancedInput from '@portal/components/AdvancedInput/AdvancedInput';
import { keepOnlyNumbers } from '@portal/utils/format';
import { Row, Col } from 'antd';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import AdvancedCheckbox from '../AdvancedCheckbox/AdvancedCheckbox';

export interface RequestCardDataProps {
  setCardLimit: (cardTag: number | null) => void;
  cardLimit: number | null;
  card?: bank.Card;
}

const CardLimitData = ({
  setCardLimit,
  cardLimit,
  card,
}: RequestCardDataProps) => {
  const [limitMasked, setLimitMasked] = useState(
    maskMoney(cardLimit ? cardLimit.toString() : '0')
  );
  const [isNotDefined, seIsNotDefined] = useState(false);

  const setLimit = (newLimit: string) => {
    setLimitMasked(maskMoney(newLimit));
    setCardLimit(Number(keepOnlyNumbers(newLimit)) / 100);
  };

  useEffect(() => {
    if (card?.limitAvailable) {
      setLimitMasked(maskMoney(card.limitAvailable.toFixed(2)));
    }
  }, [card]);

  return (
    <div className="card-limit-data">
      <h2>{translate('PAGES.NEW_CARD.CARD_LIMIT.TITLE')}</h2>
      {!card && <p>{translate('PAGES.NEW_CARD.CARD_LIMIT.SUB_TITLE')}</p>}
      <div className="card-limit-data__inputs">
        <AdvancedInput
          label={translate('PAGES.NEW_CARD.CARD_LIMIT.LIMIT_INPUT')}
          variant="standard"
          value={limitMasked}
          onChange={setLimit}
          disabled={isNotDefined}
        />
        <h4>{translate('PAGES.NEW_CARD.CARD_LIMIT.INSTRUCTION_TEXT')}</h4>
        <Row>
          <Col md={3}>
            <div className="card-limit-data__button">
              <AdvancedButton
                fullWidth
                variant="outlined"
                text={maskMoney(
                  translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.FIRST_VALUE')
                )}
                onClick={() => {
                  seIsNotDefined(false);
                  setLimit(
                    translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.FIRST_VALUE')
                  );
                }}
              />
            </div>
            <div className="card-limit-data__button">
              <AdvancedButton
                fullWidth
                variant="outlined"
                text={maskMoney(
                  translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.FOURTH_VALUE')
                )}
                onClick={() => {
                  seIsNotDefined(false);
                  setLimit(
                    translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.FOURTH_VALUE')
                  );
                }}
              />
            </div>
          </Col>
          <Col md={3}>
            <div className="card-limit-data__button">
              <AdvancedButton
                fullWidth
                variant="outlined"
                text={maskMoney(
                  translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.SECOND_VALUE')
                )}
                onClick={() => {
                  seIsNotDefined(false);
                  setLimit(
                    translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.SECOND_VALUE')
                  );
                }}
              />
            </div>
            <div className="card-limit-data__button">
              <AdvancedButton
                fullWidth
                variant="outlined"
                text={maskMoney(
                  translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.FIFTH_VALUE')
                )}
                onClick={() => {
                  seIsNotDefined(false);
                  setLimit(
                    translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.FIFTH_VALUE')
                  );
                }}
              />
            </div>
          </Col>
          <Col md={3}>
            <div className="card-limit-data__button">
              <AdvancedButton
                fullWidth
                variant="outlined"
                text={maskMoney(
                  translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.THIRD_VALUE')
                )}
                onClick={() => {
                  seIsNotDefined(false);
                  setLimit(
                    translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.THIRD_VALUE')
                  );
                }}
              />
            </div>
            <div className="card-limit-data__button">
              <AdvancedButton
                fullWidth
                variant="outlined"
                text={maskMoney(
                  translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.SIXTH_VALUE')
                )}
                onClick={() => {
                  seIsNotDefined(false);
                  setLimit(
                    translate('PAGES.NEW_CARD.CARD_LIMIT.BUTTONS.SIXTH_VALUE')
                  );
                }}
              />
            </div>
          </Col>
        </Row>
        {!card && (
          <AdvancedCheckbox
            label={translate('PAGES.NEW_CARD.CARD_LIMIT.DO_NOT_DEFINE')}
            value={isNotDefined}
            onChange={(value: boolean) => {
              seIsNotDefined(value);
              setCardLimit(null);
              setLimitMasked('');
            }}
          />
        )}
      </div>
    </div>
  );
};

export default CardLimitData;
